// src/modules/application/pages/AdminApplicationCategoriesPage.tsx
import React from "react";
import { Link } from "react-router-dom";
import { useGetActiveUserCategoriesQuery } from "../api/probationerApplicationApi";

function CategoryCard({ id, name }: { id: number; name: string }) {
  return (
    <Link
      to={`/probationer-applications/category/${id}`}
      state={{ categoryName: name, categoryId: id }}
      className="group border rounded-xl p-4 bg-white hover:shadow-sm transition relative overflow-hidden"
    >
      {/* LEFT COLOR STRIP (neutral but branded) */}
      <div className="absolute left-0 top-0 h-full w-1 bg-gray-300 group-hover:bg-black transition" />

      <div className="font-semibold text-lg">{name}</div>

      <div className="text-sm text-gray-600 mt-1">
        View approved, acknowledged and rejected applications
      </div>

      <div className="text-xs text-gray-500 mt-2">
        Applications grouped by status
      </div>
    </Link>
  );
}

export default function AdminApplicationCategoriesPage() {
  const {
    data: categories = [],
    isLoading,
    error,
    refetch,
  } = useGetActiveUserCategoriesQuery();

  const list = Array.isArray(categories) ? categories : [];
  const errMsg = (error as any)?.data?.message || (error as any)?.error || null;

  return (
    <div className="max-w-6xl mx-auto p-4 md:p-8">
      <div className="flex items-center justify-between gap-3 mb-6">
        <div>
          <h1 className="text-2xl font-bold">Admin Applications by Category</h1>
          <p className="text-sm text-gray-600">
            Select a category to view applications grouped by status.
          </p>
        </div>

        <button
          onClick={() => refetch()}
          className="px-3 py-2 rounded-md border text-sm"
        >
          Refresh
        </button>
      </div>

      {isLoading && <div className="text-sm">Loading…</div>}

      {errMsg && (
        <div className="p-3 rounded-md bg-red-50 border border-red-200 text-sm text-red-700">
          {errMsg}
        </div>
      )}

      {!isLoading && !errMsg && list.length === 0 && (
        <div className="p-4 rounded-md border bg-gray-50 text-sm text-gray-700">
          No categories found.
        </div>
      )}

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.map((c) => (
          <CategoryCard key={c.id} id={c.id} name={c.name} />
        ))}
      </div>
    </div>
  );
}
